import { action, computed, flow, makeAutoObservable, makeObservable, observable, toJS } from "mobx";
import { ColDef, SelectionChangedEvent } from '@ag-grid-enterprise/all-modules';
import { NavigateFunction } from "react-router-dom";
import { RootStore } from "../../stores/RootStore"
import { CalibraService } from "../../services/calibra.service";
import { Calibra } from "../../models/calibra";
import { Device } from "../../models/device";
import { NumberListModel } from "../../models/numberListModel";

export class CalibraStore {

    public RootStore: RootStore
    calibrasList: Array<any>;
    isFilePdf: boolean;

    columnDef: Array<ColDef>;
    navigate?: NavigateFunction;
    CalibraService: CalibraService;
    calibraId: number = 0;
    calibraItem: Calibra = new Calibra();
    calibrationTypes: Array<any> = [];
    manufacturerOptions: Array<any> = [];
    isUploadConfirmOpen: boolean = false;
    isLeavingPageConfirmOpen: boolean = false;
    uploadIdString: string = "uploadId";
    file: any;
    calibraDocuments: Array<any>;
    editMode: boolean = false;
    calibraHistories: Array<any>;
    isSaved: boolean = false;
    showValidationErrorPopup: boolean = false;
    selectedIds: number[] = [];
    gridApi: any;
    queryText: string = "";
    devicesByQueryText: Array<Device> = [];
    calibraDeviceResult: Device = null;
    isSerialNumberEmptyOpen: boolean = false;
    calibraDocumentsForDownloadPage: Array<any> = [];
    isHandycapPopup: boolean = false;
    constructor(navigate: NavigateFunction, RootStore?: RootStore, calibraId?: number) {
        this.RootStore = RootStore;
        this.navigate = navigate
        makeAutoObservable(this, {
            calibrasList: observable,
            columnDef: observable,
            calibraId: observable,
            calibraItem: observable,
            calibrationTypes: observable,
            manufacturerOptions: observable,
            calibraDocuments: observable,
            editMode: observable,
            calibraHistories: observable,
            isSaved: observable,
            showValidationErrorPopup: observable,
            selectedIds: observable,
            gridApi: observable,
            queryText: observable,
            devicesByQueryText: observable,
            calibraDeviceResult: observable,
            isUploadConfirmOpen: observable,
            isLeavingPageConfirmOpen: observable,
            isSerialNumberEmptyOpen: observable,
            isHandycapPopup: observable,
            isFilePdf: observable,

            setEditMode: action,
            setSelectedRow: action,
            clearSelectedRows: action,
            updateCalibraPicker: action,
            nullSelectedItemCalibra: action,
            onChangeQueryText: action,
            cancelUpload: action,
            cancelLeaving: action,
            setIsUploadConfirmOpen: action,
            setIsLeavingPageConfirmOpen: action,
            confirmLeavingPage: action,
            cancelSerialNumberEmptyOpen: action,
            getAllCalibras: flow,
            saveCalibra: flow,
            getCalibraById: flow,
            getDatasourceOptions: flow,
            deleteCalibrationDocumentById: flow,
            getCalibrationDocumentById: flow,
            getCalibrationDocumentByIdForDownloadPage: flow,
            getCalibrationHistories: flow,
            getCalibrationDocuments: flow,
            getCalibrationDocumentsInZip: flow,
            downloadCustomerInformation: flow,
            exportCalibras: flow,
            getCalibraDevices: flow,
            getAnyRowSelected: computed
        })

        this.calibraId = calibraId;

        this.CalibraService = new CalibraService();

        this.columnDef = [
            {
                headerName: "Kijelölés",
                field: "checkbox",
                checkboxSelection: true,
                width: 160,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true
            },
            {
                field: 'edit', headerName: 'Műveletek', maxWidth: 130,
                cellRenderer: 'btnCellRenderer',
                cellRendererParams: {
                    clicked: (data: any) => { this.navigateToCalibra(data.Id); },
                }
            },
            { field: 'ArticleNumber', headerName: 'Cikkszám', filter: 'agTextColumnFilter', sortable: true, maxWidth: 160 },
            { field: 'Manufacturer', headerName: 'Gyártó', filter: 'agTextColumnFilter', sortable: true, maxWidth: 180 },
            { field: 'ProductType', headerName: 'Típus', filter: 'agTextColumnFilter', sortable: true, maxWidth: 140 },
            { field: 'SerialNumber', headerName: 'Szériaszám', filter: 'agSetColumnFilter', resizable: true, sortable: true },
            { field: 'CalibrationDepot', headerName: 'Kalibrációt végző telephely', filter: 'agSetColumnFilter', resizable: true, sortable: true },
            { field: 'TechnicianRegistrationNumber', headerName: 'Technikus törzsszáma', filter: 'agSetColumnFilter', resizable: true, sortable: true },
            { field: 'CalibrationDateString', headerName: 'Kalibráció dátuma', filter: 'agSetColumnFilter', resizable: true, sortable: true },
            { field: 'CalibrationTypeName', headerName: 'Kalibráció típusa', filter: 'agSetColumnFilter', resizable: true, sortable: true },
        ]
    }

    navigateToCalibra(id: number) {
        this.navigate('/calibra/details/' + id);
    }

    updateCalibraItem(key: keyof Calibra, value: any) {
        (this.calibraItem[key] as any) = value;
    }

    cancelUpload = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        this.isUploadConfirmOpen = false;
    }

    setIsUploadConfirmOpen = () => {
        if (this.calibraItem != null && (this.calibraItem.SerialNumber == null || this.calibraItem.SerialNumber.length === 0)) {
            this.isSerialNumberEmptyOpen = true;
        }
        else {
            this.isUploadConfirmOpen = true;
        }
    }

    cancelSerialNumberEmptyOpen = () => {
        this.isSerialNumberEmptyOpen = false;
    }

    cancelLeaving = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        this.isLeavingPageConfirmOpen = false;
    }

    setIsLeavingPageConfirmOpen = () => {
        // this.isLeavingPageConfirmOpen = true;
        this.navigate('/calibra');

    }

    setFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.file = (<HTMLInputElement>document.getElementById(this.uploadIdString)).files[0];
        console.log('Kiválasztott file:', this.file)

        if (this.file.name.endsWith(".pdf")) {
			console.log("pdf file")
			this.isFilePdf = true;
		}
		if (!this.file.name.endsWith(".pdf")) {
			console.log("not pdf file")
			this.isFilePdf = false;
		}
    }

    setEditMode(value: boolean) {
        if (!this.hasValidationErrors || value == true) {
            this.editMode = value;
        }
    }

    cancelShowValidationErrorPopup = () => {
        this.showValidationErrorPopup = false;
    }

    setSelectedRow(event: SelectionChangedEvent) {
        this.selectedIds = event.api.getSelectedRows().map((a) => { return a.Id });
        // let rowNodes=event.api.getSelectedNodes();

        // for (let i = 0; i < rowNodes.length; i++) {
        //   if(rowNodes[i] && rowNodes[i].data)
        //   this.selectedIds.push(rowNodes[i].data.Id);

        // }

        console.log(toJS(this.selectedIds));
    }

    clearSelectedRows() {
        this.selectedIds.length = 0;
        console.log(toJS(this.selectedIds));
        this.selectedIds.splice(0, this.selectedIds.length);
        console.log(toJS(this.selectedIds));
        this.gridApi.deselectAll();
    }

    updateCalibraPicker(value: any) {
        this.queryText = value.ArticleNumber;
        this.calibraItem.ArticleNumberString = value.ArticleNumber;
        this.calibraItem.Manufacturer = value.Manufacturer;
        this.calibraItem.ProductType = value.Department;
        let talalat = this.manufacturerOptions.find(m => m.text == this.calibraItem.Manufacturer);
        if (talalat) {
            this.calibraItem.ManufacturerId = talalat.value;
        }
    }

    nullSelectedItemCalibra() {
        this.queryText = "";
        this.calibraItem.ArticleNumberString = "";
        this.calibraItem.Manufacturer = "";
        this.calibraItem.ProductType = "";
    }

    onChangeQueryText = (event: any, data: any) => {
        this.queryText = data.value
        console.log(this.onChangeQueryText)
        this.getDeviceByQueryText();
    }

    confirmLeavingPage() {
        this.isLeavingPageConfirmOpen = false;
        this.navigate('/calibra');
    }

    *getDeviceByQueryText() {
        console.log('this.RootStore.selectedStorethis.RootStore.selectedStore', this.RootStore.selectedStore);
        this.devicesByQueryText = yield this.CalibraService.GetDeviceByQueryText(this.queryText, this.RootStore.selectedStore)
    }

    *getCalibraDevices() {
        this.RootStore.addloading('getCalibraDevices');

        this.calibraDeviceResult = yield this.CalibraService.GetCalibraDevices(this.calibraItem.ArticleNumber.toString());
        if (this.calibraDeviceResult != null) {
            this.calibraItem.ProductType = this.calibraDeviceResult.Type;
            this.calibraItem.Manufacturer = this.calibraDeviceResult.Manufacturer;
        }
        this.RootStore.removeLoading('getCalibraDevices');

    }

    *getAllCalibras() {
        this.RootStore?.addloading('getAllCalibras')
        this.calibrasList = yield this.CalibraService.GetAllCalibras();
        this.RootStore?.removeLoading('getAllCalibras')
    }

    *saveCalibra(isNavigateNeeded: boolean) {
        this.isSaved = true;
        if (this.calibraItem.Id > 0) {
            this.showValidationErrorPopup = true;
        }
        if (!this.hasValidationErrors || this.calibraItem.Id == 0) {
            this.RootStore.addloading('saveCalibra');
            this.calibraId = yield this.CalibraService.SaveCalibra(this.calibraItem);
            this.RootStore.removeLoading('saveCalibra');
            if (isNavigateNeeded) {
                this.navigate('/calibra/details/' + this.calibraId);
            }
            this.getCalibraById();
            this.isSaved = false;
        }
    }

    *getCalibraById() {
        this.RootStore.addloading('getCalibraById');
        this.calibraItem = yield this.CalibraService.GetCalibraById(this.calibraId);
        console.log('this.calibraItem', this.calibraItem);
        this.getCalibrationDocuments();
        this.getCalibrationHistories(this.calibraId);
        this.getDatasourceOptions();
        this.RootStore.removeLoading('getCalibraById');
    }

    *getDatasourceOptions() {
        this.calibrationTypes = yield this.CalibraService.GetCalibrationTypes();
        this.manufacturerOptions = yield this.CalibraService.GetManufacturerOptions(this.calibraId);
    }

    *deleteCalibrationDocumentById(calibrationDocumentId: number) {
        this.RootStore.addloading('deleteCalibrationDocumentById');
        yield this.CalibraService.DeleteCalibrationDocumentById(calibrationDocumentId);
        this.getCalibrationDocuments();
        this.getDatasourceOptions();
        this.RootStore.removeLoading('deleteCalibrationDocumentById');
    }

    *deleteCalibra() {
        if (window.confirm('Biztosan törölni szeretnéd ezt a riportot?')) {
            this.RootStore.addloading('deleteCalibra');
            yield this.CalibraService.DeleteCalibra(this.calibraId);
            this.getCalibraById();
            this.RootStore.removeLoading('deleteCalibra');
        }
    }

    *getCalibrationDocumentById(calibrationDocumentId: number) {
        yield this.CalibraService.GetCalibrationDocumentById(calibrationDocumentId);
    }

    *getCalibrationDocumentByIdForDownloadPage() {
        for (let i = 0; i < this.calibraDocuments.length; i++) {
            const element = this.calibraDocuments[i];
            yield this.CalibraService.GetCalibrationDocumentById(element.Id);

        }
    }

    *confirmUpload(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        this.RootStore.addloading('UploadCalibrationDocument');
        this.isUploadConfirmOpen = false;
        let formData: FormData = new FormData();
        this.file = (document.getElementById(this.uploadIdString) as HTMLInputElement).files[0];
        formData.append('uploadFile', this.file, this.file.name);
        yield this.CalibraService.UploadCalibrationDocument(formData, this.calibraId, this.calibraItem.SerialNumber);
        console.log(this.file);
        this.getCalibrationDocuments();
        this.RootStore.removeLoading('UploadCalibrationDocument');
    }

    *downloadCustomerInformation(calibrationId: number) {
        this.RootStore.addloading('getCalibrationDocumentsInZip');
        yield this.CalibraService.GetCalibrationDocumentsInZip(calibrationId.toString());
        this.RootStore.removeLoading('getCalibrationDocumentsInZip');
    }

    *getCalibrationHistories(calibrationId: number) {
        this.calibraHistories = yield this.CalibraService.GetCalibrationHistories(calibrationId);
    }

    *getCalibrationDocuments() {
        this.calibraDocuments = yield this.CalibraService.GetCalibrationDocuments(this.calibraId);
    }

    *getCalibrationDocumentsInZip() {
        this.RootStore.addloading('getCalibrationDocumentsInZip');
        yield this.CalibraService.GetCalibrationDocumentsInZip(this.selectedIds.join(','));
        this.RootStore.removeLoading('getCalibrationDocumentsInZip');
    }

    *getCalibrationDocumentsAnonymous(calibrationId: number) {
        this.RootStore.addloading('GetCalibrationDocumentsAnonymous');
        let cicc:string=null;
        cicc = yield this.CalibraService.GetCalibrationDocumentsAnonymous(calibrationId);
        window.location.assign(cicc)        
        
        this.RootStore.removeLoading('GetCalibrationDocumentsAnonymous');
    }

    *exportCalibras() {
        this.RootStore.addloading('exportCalibras');
        let numberListModel: NumberListModel = new NumberListModel();
        numberListModel.IdList = [];
        this.selectedIds.map((item: any) => {
            numberListModel.IdList.push(item);
        })
        yield this.CalibraService.ExportCalibras(numberListModel);
        this.RootStore.removeLoading('exportCalibras');
    }

    setCookie(cname: any, cvalue: any, exdays: any) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }
    readCookie(name: any) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    get getEditMode() {
        return this.calibraItem != null && this.calibraItem.IsDeleted == false && (this.calibraItem.StatusId == 0 || this.editMode) && (this.RootStore.currentUser.IsHQCalibrator || this.RootStore.currentUser.IsStoreCalibrator);
    }

    get getValidationsCalibration() {
        if (!this.isSaved) {
            return {}
        }

        let validationErrors: Partial<Record<keyof any, string>> = {}

        if (!this.calibraItem.ArticleNumber) {
            validationErrors["ArticleNumber"] = "Cikkszám kitöltése kötelező!"
        }

        if (!this.calibraItem.Manufacturer || this.calibraItem.Manufacturer == "") {
            validationErrors["Manufacturer"] = "Gyártó kitöltése kötelező!"
        }

        if (!this.calibraItem.ProductType || this.calibraItem.ProductType == "") {
            validationErrors["ProductType"] = "Típus kitöltése kötelező!"
        }

        if (!this.calibraItem.SerialNumber) {
            validationErrors["SerialNumber"] = "Szériaszám kitöltése kötelező!"
        }

        if (!this.calibraItem.CalibrationDepot) {
            validationErrors["CalibrationDepot"] = "Kalibrációt végző telephely kitöltése kötelező!"
        }

        if (!this.calibraItem.TechnicianRegistrationNumber) {
            validationErrors["TechnicianRegistrationNumber"] = "Technikus törzsszáma kitöltése kötelező!"
        }

        if (this.calibraItem.TechnicianRegistrationNumber && this.calibraItem.TechnicianRegistrationNumber.toString().length > 5) {
            validationErrors["TechnicianRegistrationNumber"] = "Technikus törzsszáma maximálisan 5 karakterből állhat!"
        }

        if (!this.calibraItem.CalibrationDateUtc) {
            validationErrors["CalibrationDateUtc"] = "Kalibráció dátuma kitöltése kötelező!"
        }

        if (this.calibraItem.CalibrationTypeId < 1) {
            validationErrors["CalibrationTypeId"] = "Kalibráció típusa kitöltése kötelező!"
        }

        if (this.calibraDocuments == null || this.calibraDocuments.length === 0) {
            validationErrors["CalibraDocuments"] = "TV kalibrációs PDF file feltöltése kötelező!"
        }

        return validationErrors
    }

    get hasValidationErrors() {
        if (Object.keys(this.getValidationsCalibration).length === 0) {
            return false;
        }

        return true;
    }

    get getAnyRowSelected() {
        if (this.selectedIds != null && this.selectedIds.length > 0) {
            return true;
        }
        return false;
    }

    get userByQueryTextDDL() {
        return this.devicesByQueryText.map((device, index) => {
            return { title: device.Name + " - " + device.Price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " Ft", item: device, key: index };
        })

    }
}